module.exports = __webpack_public_path__ + "img/18.a19c6c6b.png";